/*
 * @Author: kian
 * @Date: 2021-11-08 17:39:55
 * @LastEditors: kian
 * @LastEditTime: 2021-11-08 17:39:56
 * @Description:
 */
export const GetAdByType = type => {
  return {
    url: `/adapi/ad/web?showType=${type}`,
    method: 'get',
  };
};
export const showSvip = () => {
  return {
    url: `https://cdn.gelonghui.com/static/web/member/showSvip.json?t=${new Date().getTime()}`,
    method: 'get',
  };
};

export const GetKeySrv = key => {
  return {
    url: `/adapi/ad/key-srv/${key}`,
    method: 'get',
  };
};
